import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_SERVER_ADMIN_URL,
  timeout: 100000000,
  headers: {
    'Content-Type': 'application/json',
  },
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token != null && token !== '') {
    config.headers.token = token
  }
  return config
},
error => {
  console.log(error)
},
)

request.interceptors.response.use(
  response => {
    if (response.status === 200 && response.data.code === 0) {
      return response.data.data
    } else {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(response.data)
    }
  },
  error => {
    console.log(error)
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(error)
  },
)

export default request
